import store from "@/store";

export const axiosRequestInterceptor = (api) => {
    api.interceptors.request.use((config) => {
        if (store.getters["http/readAuthErrorHandled"]) {
            // Bloqueia novas requisições, após o 1º erro 401
            return Promise.reject({ message: "Sessão expirada. Recarregando..." });
        }
            
        return config;
    });
}